import { generatePath, useParams } from 'react-router';
import { INDEX_PATH } from 'routes/constants';

import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

import { getValidChainId } from '../utils/getValidChainId';

const CHAIN_SUBPATH = ':chainId';
const CHAIN_DETAILS_SUBPATH = `${CHAIN_SUBPATH}/:netId?`;

const CHAINS_PATH = INDEX_PATH;
const PATH_CHAIN_DETAILS = `${CHAINS_PATH}${CHAIN_DETAILS_SUBPATH}/`;

export const chainsRoutesConfig = createRouteConfig(
  {
    chains: {
      path: CHAINS_PATH,
      generatePath: () => CHAINS_PATH,
    },
    chainDetails: {
      path: PATH_CHAIN_DETAILS,
      generatePath: (chainId: string, netId?: string) =>
        generatePath(PATH_CHAIN_DETAILS, { chainId, netId: netId ?? null }),
      useParams: () => {
        const { chainId, netId } = useParams();

        return {
          chainId: getValidChainId(chainId),
          netId,
        };
      },
    },
  },
  INDEX_PATH,
);
